import { Component, Inject, Renderer2 } from '@angular/core';
import * as AOS from 'aos';

import { Title, Meta } from '@angular/platform-browser';

import { Constants } from '../../common/constants';
import { SeoService } from 'src/app/common/seo.service';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-planning-cloud-capacity-blog',
  templateUrl: './planning-cloud-capacity-blog.component.html',
  styleUrls: ['./planning-cloud-capacity-blog.component.css']
})
export class PlanningCloudCapacityBlogComponent {

  baseUrl=Constants.baseUrl;
  constructor(
    private titleService: Title,
    private metaService: Meta, private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document
  ) {}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/planning-cloud-capacity/"
  },
  "headline": "Planning Cloud capacity for unexpected Spikes in Server Workloads",
  "description": "As most CIOs, cloud engineers, and 48% of IT decision-makers agree - unpredictable workload demands or rapid user base growth is one of the biggest challenges they face when dealing with server workload constraints.",
  "image": "https://mitresource.com/assets/images/blogs/planning-cloud.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2023-05-15"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Client Story: How we helped client achieve 50% Cost savings with tried and tested cloud optimization strategies');

    this.metaService.addTags([
      { name: 'description', content: '64% of respondents in a recent survey identified cost management and containment as the top concerns in running the cloud!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Client Story: How we helped client achieve 50% Cost savings with tried and tested cloud optimization strategies' },
      { property: 'og:url', content: 'https://mitresource.com/cloud-cost-optimization/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/cloud-cost-optimization.png' },
      { property: 'og:description', content: '64% of respondents in a recent survey identified cost management and containment as the top concerns in running the cloud.' },
    ]);
  }

}
